<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.ksny"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.jsny"></el-date-picker>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="formInline.pp"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <!-- <el-button type="warning" @click="getList" class="chaxun">重置</el-button> -->
        <el-button type="warning" @click="print_all" class="chaxun">批量打印预交费通知单</el-button>
      </el-form-item>
    </el-form>
    <!-- <el-table :data="tableData" :height="conheight" style="width: 100% !important;border-top: 1px solid #000 !important;border-left: 1px solid #000 !important;"> -->
    <el-table :data="tableData" :height="conheight" style="width: 100% !important;" border>
      <el-table-column label="序号" width="50"><template slot-scope="scope">{{scope.$index+1}}</template></el-table-column>
      <el-table-column prop="FDMC" label="门店" width="100"></el-table-column>
      <el-table-column prop="NY" label="月结" width="60"></el-table-column>
      <el-table-column prop="HTH" label="合同号" width="80"></el-table-column>
      <el-table-column prop="SHMC" label="商户名称" width="120"></el-table-column>
      <el-table-column prop="JYPP" label="品牌" width="100"></el-table-column>
      <el-table-column prop="JZMJ" label="建筑面积" width="80"></el-table-column>
      <el-table-column prop="BDZJ" label="保底租金" width="80"></el-table-column>
      <el-table-column prop="WYGLF" label="物业管理费" width="80"></el-table-column>
      <el-table-column prop="XCTGF" label="宣传推广费" width="80"></el-table-column>
      <el-table-column prop="CKZJ" label="仓库租赁费" width="80"></el-table-column>
      <el-table-column prop="WBF" label="外摆费" width="60"></el-table-column>
      <el-table-column prop="SYXTF" label="收银系统使用费元/台/月" width="60"></el-table-column>
      <el-table-column prop="HYFWF" label="固定会员服务费" width="60"></el-table-column>
      <el-table-column prop="KKHJ" label="供应商扣款合计金额" width="80"></el-table-column>
      <el-table-column prop="BZ" label="备注"></el-table-column>
      <el-table-column prop="HJ" label="会计" width="60"></el-table-column>
      <el-table-column prop="DZLH" label="对账电话" width="100"></el-table-column>
      <el-table-column prop="LC" label="楼层" width="80"></el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <span class="menuname"><el-link icon="el-icon-download" @click="print(scope.row)">打印预交费通知单</el-link></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "yjfytzd",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      // {value: '海雅百货东莞南城店',label: '海雅百货东莞南城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        ksny:'',
        jsny:'',
        hth:'',
        pp:''
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
    };
  },
  methods: {
    print_all(){
      window.open("/fvue/print_yjftzd_all","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    print(row){//打印
        window.open("/fvue/print_yjftzd?DJBH="+row.HTH+"&NY="+row.NY,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+month;
      return formattedDate;
    },
    onSubmit() {
      this.tableData = [];
      let sql = "";
      if(this.user.username=='付婉婷'){//查看全部
        sql = "select * from V_ZSPT_YJTZD where 1=1 ";
      }else{
        sql = "select * from V_ZSPT_YJTZD where (WLDW='"+this.user.account.replaceAll("SZHY","")+"' or kj=(select fullname_ from uc_user where id_='"+this.user.userId+"')) ";
      }
      if(this.formInline.md.length>0){
        sql += " and instr(FDMC,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.ksny!=null && this.formInline.ksny!='' && this.formInline.jsny!=null && this.formInline.jsny!=''){
        sql += " and NY BETWEEN '"+this.getDate(this.formInline.ksny)+"' and '"+this.getDate(this.formInline.jsny)+"'";
      }
      // else{
      //   sql += " and NY = to_char(sysdate,'yyyymm')";
      // }
      if(this.formInline.hth.length>0){
        sql += " and instr(HTH,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.pp.length>0){
        sql += " and instr(JYPP,'"+this.formInline.pp+"',1,1)>0";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("yjsql",sql);
        }
      });
    },
    getList(){
      let sql = "select * from V_ZSPT_YJTZD WHERE NY BETWEEN to_char(add_months(sysdate,-2),'yyyymm') and to_char(add_months(sysdate,+1),'yyyymm')  ";
      if(this.user.username=='付婉婷'){//查看全部
      }else{
       sql += "and (WLDW='"+this.user.account.replaceAll("SZHY","")+"' or kj=(select fullname_ from uc_user where id_='"+this.user.userId+"'))";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("yjsql",sql);
        }
      });
    },
  },
  mounted(){
    this.getList();
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 2); // 将月份减去1
    this.formInline.ksny=currentDate;

    let currentDate1 = new Date(); // 获取当前日期和时间
    currentDate1.setMonth(currentDate1.getMonth() + 1); // 将月份减去1
    this.formInline.jsny=currentDate1;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
</style>